import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import LazyLoader from 'react-lazyload';
import { connect } from 'react-redux';
import { gridConfig } from '@client/config';
import {
    UPCOMING_CAMPAIGNS,
    SHORT_DELIVERY,
} from '@client/config/constants';
import { fetchCategorySubline } from '@client/redux/modules/myloungeMetadata/actions';

import Campaign from './Campaign';

import styles from './mobileCampaigns.scss';

/* eslint-disable react/jsx-no-bind */


const ID_OPEN = 'open';
export class MobileCampaigns extends React.Component {

    constructor() {
        super();
        this.state = {};
        this.gridCalculation = gridConfig.open.gridCalculation;
        this.bannerRatio = gridConfig.open.bannerRatio;
        this.filteredGrid = gridConfig.open.filteredGrid;
        this.extraHeightPercent = 0;
    }

    render() {
        const {
            id,
            myloungeData,
            width,
            height,
            params,
            location,
            articleImages,
        } = this.props;

        if (!myloungeData || !myloungeData.campaigns || !myloungeData.grid) {
            return null;
        }

        const { campaigns, grid } = myloungeData;
        const { query } = location;
        const filterTag = { params };

        const columnCount = 1;
        const elements = grid[columnCount];
        let campaignIndex = 0; // only for upcoming campaings, banner position is not counted

        const containerWindowRatio = 0.96; // This is the percentage of the window width the image covers.
        const upcomingImgRatio = 0.47;
        const imgRatio = 0.58;
        const upcomingHeight = width * upcomingImgRatio * containerWindowRatio;
        const normalHeight = width * imgRatio;

        return (
            <div
                styleName="wrapper"
                id={`campaigns-${id}`}
            >
                {elements.map(element => {
                    // return campaign or custom element, depending on type
                    const isUpcoming = id === UPCOMING_CAMPAIGNS;
                    const campaign = campaigns[element.ref];
                    const campaignHeight = isUpcoming ? upcomingHeight : normalHeight;
                    const campaignArticleImages = articleImages && articleImages[campaign.campaignIdentifier];

                    return campaign && (
                        <LazyLoader offset={height} height={campaignHeight} key={element.ref}>
                            <Campaign
                                key={element.ref}
                                campaign={campaign}
                                isUpcoming={isUpcoming}
                                dimension={`${element.w}x${element.h}`}
                                campaignStyles={{}}
                                showDelivery={filterTag === SHORT_DELIVERY}
                                showPopover={!this.state.hidePopover && element.ref === query.event}
                                closePopover={this.closePopover}
                                position={`${++campaignIndex},${columnCount}`}
                                minHeight={campaignHeight}
                                articleImages={campaignArticleImages}
                            />
                        </LazyLoader>
                    );
                })}
            </div>
        );
    }

    componentDidMount() {
        const { id } = this.props;
        if (id === ID_OPEN) {
            this.props.fetchCategorySubline();
        }
    }
}

MobileCampaigns.propTypes = {
    id: PropTypes.string.isRequired,
    myloungeData: PropTypes.object.isRequired,
    params: PropTypes.object,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    increment: PropTypes.func,
    location: PropTypes.object,
    inIFrame: PropTypes.bool,
    fetchCategorySubline: PropTypes.func.isRequired,
    articleImages: PropTypes.arrayOf(PropTypes.string),
};

MobileCampaigns.defaultProps = {
    filterTag: 'all'
};

const mapDispatchToProps = {
    fetchCategorySubline,
};

// TODO: typings is getting broken when using compose
export default connect(null, mapDispatchToProps)(CSSModules(styles, { allowMultiple: true })(MobileCampaigns));
